import habitat from 'preact-habitat';
import { ROOT_SELECTOR } from './constants';
import { MathJax } from './components/MathJax';
import { IconsSprite } from './components/Icon/icons-sprite';
import { Widget } from './widget';

const App = () => (
  <>
    <IconsSprite />
    <MathJax />
    <Widget />
  </>
);

const _habitat = habitat(App);

_habitat.render({
  selector: ROOT_SELECTOR,
  clean: true,
});
